import React, { useContext, useRef, useState, useEffect } from "react";
import logo from "../../assets/images/bitamin.png";
import background from "../../assets/images/background.png";
import call from "../../assets/images/call.png";
import location from "../../assets/images/Icon metro-location.png";
import logo_s from "../../assets/images/sub_logo.png";
import logo_statice from "../../assets/images/logo-sabadi.png";
import { AiFillSetting } from "react-icons/ai";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";
import { useNavigate } from "react-router-dom";

import "./Header.scss";
const Header = ({
  headers,
  setHeaders,
  coverImg,
  setCoverImg,
  logo,
  setLogo,
  cover,
}) => {
  // console.log("juu", headers);
  // console.log("img", coverImg);
  console.log("logo", logo);
  const { isLogged, userInfo } = useContext(AuthenticationContext);
  const navigate = useNavigate();
  console.log("heder", headers);
  return (
    <div>
      <div className="col-12 mainCover">
        <div className="onImage overlay"></div>

        <div className="onImage center row">
          {headers.length > 0 && (
            <>
              {userInfo?.supplier_list?.includes(headers[0].id) ? (
                <div className="d-flex justify-content-end mt-2">
                  <button
                    style={{ height: "45px", padding: "8px" }}
                    type="button"
                    className="btn btn-outline-light"
                    onClick={() => navigate(`/admin-panel/${headers[0].id}`)}
                  >
                    پنل ادمین{" "}
                    <AiFillSetting style={{ fontSize: "22px" }}></AiFillSetting>
                  </button>
                </div>
              ) : (
                ""
              )}
            </>
          )}

          {/* <div className="rightSide col-3 col-sm-2">
            <div className="contact">
              <button
                href="#contact"
                data-bs-toggle="modal"
                data-bs-target="#ModalContact"
              >
                <div className="round call">
                  <img src={call} alt="call" />
                </div>
              </button>
            </div>
          </div> */}

          <div className="container align-self-center">
            <div
              className="d-flex align-items-center box-info "
              style={{ paddingRight: "100px" }}
            >
              {logo ? (
                <div className="box-pic">
                  <div className="round businessImage">
                    <img
                      src={`http://sabadi.tatdemo.ir/${logo}`}
                      alt="businessImage"
                    />
                  </div>
                </div>
              ) : (
                <div className="box-pic">
                  <div className="round businessImage">
                    <img src={logo_statice} />
                  </div>
                </div>
              )}

              <div className="info w-50 mx-5" style={{}}>
                {headers.title != "" && headers.length > 0 ? (
                  <div className="name2">{headers[0].title}</div>
                ) : (
                  ""
                )}

                {/* <br /> */}

                {headers.address != "" && headers.length > 0 ? (
                  <div className="adrs">
                    <span>
                      {/* <img
                        src={location}
                        alt="location"
                        width={15}
                        height={23}
                      /> */}
                    </span>
                    <span className="address"> {headers[0].address}</span>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="d-flex justify-content-center w-50 ">
                <img className="box-img" style={{}} src={logo_s}></img>
              </div>
            </div>
          </div>

          {/* <div className="d-none d-sm-block col-1"></div> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
